/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { useBreadcrumb } from "hooks/useBreadcrumb";
import { useDispatch, useSelector } from "react-redux";
import { getPaymentHistory } from "redux/slices/getPaymentHistorySlice";
import { getName, getPoliciesOptions } from "js/formatting";
import { getPrimaryOwnerFromParties } from "js/utilities";

import PaymentHistoryTab from "components/Payments/Billing/PaymentHistoryTab";
import EverlakeLoadingOverlay from "components/General/EverlakeLoadingOverlay";
import RELEASING_AutoCompleteComboBox from "components/General/AutoCompleteComboBox/RELEASING_AutoCompleteComboBox";

export default function Billing() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { policies } = useSelector((state) => state.data);
  const [isAllApiLoading, setIsAllApiLoading] = useState(true);
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState({
    displayAs: t("AutoComplate-display-as"),
    selectedPolicyDisplayAs: t("AutoComplate-display-as"),
    value: "all",
  });
  let [searchParams, setSearchParams] = useSearchParams();
  const [paymentHistories, setPaymentHistories] = useState([]);

  const getDisplayDataRowsAfterFilter = (dataRows) => {
    return !searchParams.get("policyId") ||
      searchParams.get("policyId") === "all"
      ? dataRows
      : dataRows.filter(
          (history) => history.policyId === searchParams.get("policyId")
        );
  };
  useEffect(() => {
    if (policies?.length > 0) {
      const policySelectionArray = getPoliciesOptions(policies);

      const policiesOptions = policySelectionArray.map((policy) => ({
        ...policy,
        selectedPolicyDisplayAs: `${policy?.prodType}: ${policy.value}`,
      }));

      setOptions([selectedOption, ...policiesOptions]);

      if (policiesOptions?.length === 1) {
        setSelectedOption(policiesOptions[0]);
      } else if (searchParams.get("policyId") !== "all") {
        let policy = policies.find(
          (p) => p.contractID === searchParams.get("policyId")
        );
        if (policy)
          setSelectedOption(
            policiesOptions?.find((po) => po.value === policy.oldPolicy)
          );
      }
      dispatch(
        getPaymentHistory(
          policies.map((policy) => {
            const policyOwner = getPrimaryOwnerFromParties(policy?.parties);

            return {
              contractId: policy.contractID,
              policyId: policy?.contractID,
              oldPolicy: policy?.oldPolicy,
              policyName: `${getName(policyOwner?.person)}`,
              policyNumber: policy?.contractID,
            };
          })
        )
      )
        .then((response) => {
          setIsAllApiLoading(false);
          if (response.meta.requestStatus === "fulfilled") {
            setPaymentHistories(response.payload);
          }
        })
        .catch((e) => {
          setIsAllApiLoading(false);
          console.error(e);
        });
    }
  }, [policies]);
  useEffect(() => {
    let contractID = policies?.find(
      (p) => p.oldPolicy === selectedOption?.value
    )?.contractID;
    setSearchParams({
      policyId: contractID ?? "all",
    });
  }, [selectedOption]);

  useBreadcrumb([
    { name: t("AuthCustomerBilling-home"), url: "/policies" },
    { name: t("AuthCustomerBilling-payments"), url: "/payment" },
    { name: t("AuthCustomerBilling-billing"), url: "#" },
  ]);

  return (
    <>
      <div className="container">
        <h1>{t("AuthCustomerBilling-title")}</h1>
        <p>{t("AuthCustomerBilling-subtitle")}</p>
        <hr />
      </div>

      <EverlakeLoadingOverlay
        isLoading={isAllApiLoading}
        loadingText={t("AuthCustomerBilling-loadingText")}
      >
        <div className="container ui-component-spacing">
          <div className="flex flex-col lg:flex-row lg:items-center">
            <div className="relative md:w-[40%]">
              <RELEASING_AutoCompleteComboBox
                labelName={t("CustomerForms-select-policy")}
                inputPlaceholderText={t("AutoComplate-select-your-contract")}
                options={options}
                selectedOption={selectedOption}
                setSelectedOption={setSelectedOption}
                readOnly={policies?.length === 1}
                showBadge={true}
              />
            </div>
          </div>
          <PaymentHistoryTab
            data={getDisplayDataRowsAfterFilter(paymentHistories)}
          />
        </div>
      </EverlakeLoadingOverlay>
    </>
  );
}
